import { Box, InputBase } from '@mui/material'
import React from 'react'
import { Icon } from '@iconify/react/dist/iconify.js'

const SearchInput = ({ onChange, placeholder = "Search for anything.........." }) => {
    const handleChange = (e) => {
        if (onChange) {
            onChange(e.target.value);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                border: "0.5px solid #A9B7FD",
                borderRadius: "15px",
                padding: "5px 15px",
                flex: 1,  // 💡 Makes it take up all remaining space
                backgroundColor: "transparent",
            }}
        >
            <Icon icon="ant-design:search-outlined" style={{ marginRight: "5px", color: "#B3B3B3" }} width="20" height="20" />

            <InputBase
                placeholder={placeholder}
                onChange={handleChange}
                sx={{
                    flex: 1,
                    typography: "h6",
                    color: "text.primary",
                }}
            />
        </Box>
    )
}

export default SearchInput